import { render, staticRenderFns } from "./Sazonalidade.vue?vue&type=template&id=48f583d8"
import script from "./Sazonalidade.vue?vue&type=script&lang=js"
export * from "./Sazonalidade.vue?vue&type=script&lang=js"
import style0 from "./Sazonalidade.vue?vue&type=style&index=0&id=48f583d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports